import { Input, List } from "antd";
import React, { useState, useMemo } from "react";
import { RequestDto } from "../dtos/RequestDto";
import {MethodTag} from "./MethodTag";

interface RequestsListInterface {
    data: RequestDto[];
    onItemClick: (item: RequestDto) => void;
}

export const RequestsList: React.FC<RequestsListInterface> = ({ data, onItemClick }) => {
    const [filter, setFilter] = useState('');

    const filteredData = useMemo(() => {
        if (!filter) return data;

        const lowerFilter = filter.toLowerCase();
        return data.filter(item =>
            item.path.toLowerCase().includes(lowerFilter) ||
            item.method.toLowerCase().includes(lowerFilter)
        );
    }, [data, filter]);

    return (
        <div
            id="scrollableDiv"
            style={{
                height: 'calc(100% - 64px)',
                overflow: 'auto',
                padding: '0 16px',
                border: '1px solid rgba(140, 140, 140, 0.35)',
            }}
        >
            <div style={{ padding: '16px 0' }}>
                <Input.Search
                    placeholder="Filter by path or method..."
                    value={filter}
                    onChange={(e) => setFilter(e.target.value)}
                    allowClear
                />
            </div>
            <List
                itemLayout="vertical"
                dataSource={filteredData}
                renderItem={item => (
                    <List.Item onClick={() => onItemClick(item)} style={{cursor: 'pointer'}}>
                        <List.Item.Meta
                            title={<a><MethodTag method={item.method} /> - {item.path}</a>}
                            description={
                                <div>
                                    <div>{item.id}</div>
                                    <div style={{fontSize: '12px', color: '#666'}}>{item.time}</div>
                                </div>
                            }
                        />
                    </List.Item>
                )}
            />
        </div>
    );
}